var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransitions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6507 8.33919C17.5596 8.15825 17.4201 8.00608 17.2477 7.89956C17.0753 7.79304 16.8768 7.73632 16.6742 7.73571H11.1879V1.15221C11.1998 0.911571 11.132 0.673742 10.9951 0.475426C10.8583 0.27712 10.66 0.129364 10.4308 0.0549596C10.2106 -0.017517 9.97295 -0.0183312 9.75216 0.0526367C9.53137 0.123603 9.33874 0.262713 9.20193 0.449969L0.423936 12.5198C0.313954 12.6786 0.247914 12.8639 0.232499 13.0565C0.217084 13.2492 0.252844 13.4425 0.336156 13.617C0.412878 13.8164 0.546158 13.9891 0.719634 14.1138C0.893109 14.2386 1.09924 14.3099 1.31271 14.3192H6.79896V20.9027C6.79913 21.134 6.87244 21.3595 7.00841 21.5467C7.14439 21.7339 7.33607 21.8734 7.55606 21.9451C7.6663 21.9793 7.78081 21.9977 7.89621 22C8.06934 22.0004 8.24012 21.9598 8.39459 21.8817C8.54906 21.8035 8.68283 21.6899 8.78498 21.5501L17.563 9.48033C17.6812 9.31662 17.7519 9.12346 17.7675 8.92212C17.783 8.72077 17.7426 8.51907 17.6507 8.33919ZM8.99346 17.5232V13.222C8.99346 12.9309 8.87785 12.6519 8.67208 12.4461C8.4663 12.2403 8.18722 12.1247 7.89621 12.1247H3.50721L8.99346 4.53174V8.83296C8.99346 9.12397 9.10906 9.40305 9.31483 9.60883C9.52061 9.81461 9.79969 9.93025 10.0907 9.93025H14.4797L8.99346 17.5232Z",
    fill: "#FDAA6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransitions);
export default __webpack_public_path__ + "static/media/transitions.f6de8a5db782faf7f4384893c5c79190.svg";
export { ForwardRef as ReactComponent };